import  axiosI  from '../Service/service';
import { userCheckIn } from './index';
import {
    GET_PLAN,ADD_CREDIT_CARD,
    CANCEL_PLAN,
    GET_TRANSACTION_DETAIL,
    ENABLE,
    DISABLE,
    PAYMENT_SUCCESSFUL
} from './actionTypes';

export const getPlanAction=()=>{
    return (dispatch => {
        return axiosI.get(`/GetNewPlans/Business/''`).then(({data})=>{
            dispatch({
                type: GET_PLAN,
                payload: data.results
            });
            return data.results;
        }).catch((err)=>{
            console.log("Plan error",err);
            return null;
        })
    })
};

export const addCreditCardAction=(cardData)=>{
    return (dispatch => {
        return axiosI.post(`/BusinessPayment`,cardData).then(({data})=>{
            dispatch({
                type: ADD_CREDIT_CARD,
                payload: data.results
            });
            return data.results;
        })
    })
};

export const cancelPlanAction=(cancelData)=>{
    return (dispatch => {
        dispatch({type: ENABLE, payload: true});
        return axiosI.post(`/CancelBusinessPlan`,cancelData).then(({data})=>{
            if(data.results.Responsecode){
                dispatch({
                    type: CANCEL_PLAN,
                    payload: cancelData,
                    loginData: data.results
                });
            }
            dispatch({type: DISABLE, payload: false});
            return data.results;
        }).catch(()=>{
            dispatch({type: DISABLE, payload: false});
        })
    })
};

export const getTransactionDetailAction=(transactionId,paymentType)=>{
    return (dispatch => {
        return axiosI.get(`/GetTransctionDetails/${transactionId}/${paymentType}`).then(({data})=>{
            dispatch({
                type: GET_TRANSACTION_DETAIL,
                payload: data.results
            });
            return data.results;
        })
    })
};
export const editPaymentDetails=(cardData)=>{
  return (dispatch => {
    return axiosI.post(`/UpdateCreditCardDetails`,cardData).then(({data})=>{
      dispatch({
        type: ADD_CREDIT_CARD,
        payload: data.results
      });
      return data.results;
    })
  })
};

export const paymentSuccessful = (data) => {
    return dispatch => {
      // getUserAction().then((data)=>{
        let checkIndata = {
          "Address": data.results.BusinessUser.Address,
          "GooglePlaceId": data.results.BusinessUser.PlaceID,
          "Latitude": data.results.BusinessUser.Address_Lat,
          "Longitude": data.results.BusinessUser.Address_Long,
          "PageNumber": 1,
          "PageSize": 15,
          "PlaceName": data.results.AppUser.FirstName,
          "PlaceType": data.results.BusinessUser.Address_Type,
          "UserId": data.results.AppUser.UserId
        };
        userCheckIn(checkIndata);
      // })(dispatch);
      dispatch({
        type: PAYMENT_SUCCESSFUL
      })
    }
};